<template>
  <q-slide-transition :duration="duration" @show="$emit('show')" @hide="$emit('hide')">
    <div v-show="currentVisible">
      <slot />
    </div>
  </q-slide-transition>
</template>

<script>
export default {
  name: 'SlideTransition',
  props: {
    value: Boolean,

    duration: {
      type: Number,
      default: 300,
    },
  },
  computed: {
    currentVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
